// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cx-b";
export var colorBlue = "_cx-8";
export var colorDot = "_cx-0";
export var colorDotLarge = "_cx-2";
export var colorDotSmall = "_cx-1";
export var colorGreen = "_cx-7";
export var colorGrey = "_cx-3";
export var colorOrange = "_cx-5";
export var colorPink = "_cx-a";
export var colorPurple = "_cx-9";
export var colorRed = "_cx-4";
export var colorYellow = "_cx-6";